import { formatDateToYYYYMMDD } from "@/common/util/date-util";
import { HistoryDto } from "../../types/dto/history-dto";
import { Body14Regular } from "../typography/Body14Regular";

interface Props {
  items: HistoryDto[];
}

export const AdminHomeHistorySimplePanel: React.FC<Props> = ({ items }) => {
  return (
    <div className="flex flex-col px-[16px] py-[12px] border-[1px] border-semantic-divider rounded-[4px] bg-primary-white w-[788px] h-[230px]">
      {items.map((item, index) => (
        <div key={item.id}>
          <AdminHomeHistorySimpleItem item={item} />
          {index < items.length - 1 && (
            <div className="border-b border-semantic-divider" />
          )}
        </div>
      ))}
    </div>
  );
};

interface Props2 {
  item: HistoryDto;
}

const AdminHomeHistorySimpleItem: React.FC<Props2> = ({ item }) => {
  return (
    <div className="flex justify-between items-center py-[8px] cursor-pointer">
      <Body14Regular className="text-semantic-text-body truncate max-w-[590px]">
        {`${item.modifiedBy}님이 ${item.fieldDetail}를 수정했습니다.`}
      </Body14Regular>
      <Body14Regular className="text-semantic-text-tertiary">
        {formatDateToYYYYMMDD(new Date(item.modifiedAt))}
      </Body14Regular>
    </div>
  );
};
